import type {PageProps} from 'gatsby'
import {graphql} from 'gatsby'
import React from 'react'

import Footer from '@/components/footer'
import Header from '@/components/header'
import SEO from '@/components/seo'
import type {NotFoundPageQuery} from '@/graphql-types'
import handleNoPrismicData from '@/utils/handle-no-prismic-data'
import {withPrismicUnpublishedPreview} from '@/utils/with-unpublished-prismic-preview'
import {Main} from '@helios/shared/components/skip-to-content'
import {useLocale} from '@helios/shared/providers/locale'
import {NotFound} from '@helios/shared/sections/404'
import type {GatsbyHeadProps} from '@helios/shared/types/gatsby-head'

type Props = PageProps<NotFoundPageQuery>

const NotFoundPage = ({data}: Props) => {
    const content = data.prismicNotFoundPage.data
    const {isPreLaunch} = useLocale()

    if (!content) {
        return handleNoPrismicData()
    }

    return (
        <>
            <Header hideLeftNav={isPreLaunch} hideRightNav={isPreLaunch} />

            <Main>
                <NotFound
                    content={{
                        ...content,
                        ctaText: content.cta_text,
                        ctaLink: content.cta_link,
                    }}
                />
            </Main>

            <Footer />
        </>
    )
}

export const Head = ({location, pageContext, data}: GatsbyHeadProps<NotFoundPageQuery>) => {
    const pageData = data.prismicNotFoundPage.data

    return (
        <SEO
            location={location}
            pageContext={pageContext}
            title={pageData.meta_title}
            description={pageData.meta_description}
            openGraphImageUrl={pageData.open_graph_image?.url}
        />
    )
}

export const query = graphql`
    query NotFoundPage($locale: String!) {
        prismicNotFoundPage(lang: {eq: $locale}) {
            _previewable
            data {
                meta_title
                meta_description
                open_graph_image {
                    url
                }
                title
                body
                cta_text
                cta_link {
                    ...PrismicLink
                }
            }
        }
    }
`

export default withPrismicUnpublishedPreview(NotFoundPage)
